import { render, staticRenderFns } from "./create-diagnosis.vue?vue&type=template&id=309bf3ea&scoped=true"
import script from "./create-diagnosis.vue?vue&type=script&lang=js"
export * from "./create-diagnosis.vue?vue&type=script&lang=js"
import style0 from "./create-diagnosis.vue?vue&type=style&index=0&id=309bf3ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309bf3ea",
  null
  
)

export default component.exports